/* eslint-disable lingui/text-restrictions */
import { t } from "@lingui/macro";
import { templatesList } from "@reactive-resume/utils";
import { normalizeToFileName } from "@reactive-resume/utils";
import { motion } from "framer-motion";

export const TemplatesSection = () => (
  <section id="sample-resumes" className="relative py-24 sm:py-32">
    <div className="container flex flex-col gap-12 lg:min-h-[600px] lg:flex-row lg:items-start">
      <div className="space-y-4 lg:mt-16 lg:basis-96">
        <h2 className="text-4xl font-bold">{t`Modèles`}</h2>

        <div className="space-y-3 leading-relaxed">
          <p>
            {t`Partez d’un modèle professionnel prêt à l’emploi et créez un CV qui vous ressemble vraiment.`}
          </p>
          <p>
            {t`Personnalisez chaque détail : couleurs, polices, titres, sections, contenus, ordre des blocs et mise en page. En quelques minutes, vous obtenez un CV clair, moderne et adapté à votre profil.`}
          </p>
          <p>
            {t`Créez plusieurs versions selon les offres visées, ajustez votre présentation pour chaque candidature et appuyez-vous sur l’IA pour améliorer vos textes, reformuler vos expériences ou corriger votre rédaction.`}
          </p>
          <p>
            {t`Résultat : un CV plus professionnel, plus impactant et plus facile à lire, exportable en PDF et conçu pour convaincre les recruteurs tout en restant compatible avec les outils ATS.`}
          </p>
        </div>
      </div>

      <div className="w-full overflow-hidden lg:absolute lg:right-0 lg:max-w-[55%]">
        <motion.div
          animate={{
            x: [0, templatesList.length * 200 * -1],
            transition: {
              x: {
                duration: 30,
                repeat: Number.POSITIVE_INFINITY,
                repeatType: "mirror",
              },
            },
          }}
          className="flex items-center gap-x-6"
        >
          {templatesList.map((template, index) => (
            <motion.a
              key={index}
              target="_blank"
              rel="noreferrer"
              href={`templates/pdf/${normalizeToFileName(template)}.pdf`}
              className="max-w-none flex-none"
              viewport={{ once: true }}
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
            >
              <img
                alt={template}
                loading="lazy"
                src={`/templates/jpg/${normalizeToFileName(template)}.jpg`}
                className="aspect-[1/1.4142] h-[400px] rounded object-cover lg:h-[600px]"
              />
            </motion.a>
          ))}
        </motion.div>

        <div className="pointer-events-none absolute inset-y-0 left-0 hidden w-1/2 bg-gradient-to-r from-background to-transparent lg:block" />
      </div>
    </div>
  </section>
);
